var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSurveyIconTrackManageProjectQuality({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 6a.74.74 0 0 0-.75.75v8.313c0 .437.313.75.75.75a.74.74 0 0 0 .75-.75V6.75A.76.76 0 0 0 6.5 6zm-5 5a.74.74 0 0 0-.75.75v3.5c0 .438.313.75.75.75a.74.74 0 0 0 .75-.75v-3.5A.76.76 0 0 0 1.5 11zm15-11A1.5 1.5 0 0 0 15 1.5v.25l-2.969 2.375A1.472 1.472 0 0 0 11.5 4c-.219 0-.375.063-.563.125L7.97 1.75c0-.094.031-.156.031-.25C8 .687 7.312 0 6.5 0A1.5 1.5 0 0 0 5 1.5c0 .156 0 .281.031.406L1.875 5.063C1.75 5.03 1.625 5 1.5 5A1.5 1.5 0 0 0 0 6.5C0 7.344.656 8 1.5 8A1.5 1.5 0 0 0 3 6.5c0-.125-.031-.25-.063-.375l3.157-3.156C6.219 3 6.344 3 6.5 3c.188 0 .375-.031.531-.094L10 5.281V5.5c0 .844.656 1.5 1.5 1.5A1.5 1.5 0 0 0 13 5.5c0-.063-.031-.125-.031-.219l2.969-2.375c.187.063.343.094.562.094A1.5 1.5 0 0 0 18 1.5c0-.813-.688-1.5-1.5-1.5zm-5 10a.74.74 0 0 0-.75.75v4.375c0 .406.313.75.75.75a.76.76 0 0 0 .75-.75V10.75a.76.76 0 0 0-.75-.75zm5-4a.74.74 0 0 0-.75.75v8.5c0 .438.313.75.75.75a.74.74 0 0 0 .75-.75v-8.5A.76.76 0 0 0 16.5 6z",
    fill: "#233145"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyIconTrackManageProjectQuality);
export default __webpack_public_path__ + "static/media/survey-icon-track-manage-project-quality.b70562cc6e6a9dcda94e14a3be383f9f.svg";
export { ForwardRef as ReactComponent };